import { CompanyResponse } from './company';
import { SponsorShipUpdatePlanResponse } from './sponsorship-plans';
import { StudentSocietyResponse } from './student-society';

export enum SponsorshipKindEnum {
  conversation = 'conversation',
  request = 'request',
  invitor_onboarded = 'invitor_onboarded',
  plan_change_notification = 'plan_change_notification',
}

export enum SponsorshipInitiatorEnum {
  Company = 'Company',
  StudentSociety = 'StudentSociety',
}

export enum SponsorshipInvitationStateEnum {
  rejected = 'rejected',
  pending = 'pending',
  accepted = 'accepted',
}

export interface sponsorCompaniesResponse {
  data: Array<SponsorCompanyResponse>;
}

export interface SponsorCompanyResponse {
  id: string;
  attributes: SponsorCompanyAttributes;
  type: 'sponsorship';
}

export interface SponsorCompanyAttributes {
  id: string;
  student_society_id: string;
  company: CompanyResponse;
  company_id: string;
  sponsorship_plan: SponsorShipUpdatePlanResponse;
  kind?: SponsorshipKindEnum;
  company_seen: boolean;
  cover_letters: string;
  manager_id: string;
  message_id: string;
  room_id: string;
  sponsorship_plan_id: string;
  state: SponsorshipInvitationStateEnum;
  initiator?: SponsorshipInitiatorEnum;
  student_society: StudentSocietyResponse;
}

export interface SponsorCompanyInviteResponse {
  data: {
    id: string;
    attributes: SponsorCompanyAttributes;
    type: 'sponsorship_invitation';
  };
}
